import { useExternalStore } from '@/hooks/useExternalStore';
import type { AuthSnapshot } from '@/types/auth';

import { authSession } from './authSession';

/** The sign-in, kept current. */
export function useAuth(): AuthSnapshot {
    return useExternalStore(authSession);
}
